import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import Button from 'Components/Atoms/Button/Button';
import Dropdown from 'Components/Atoms/Dropdown/Dropdown';
import DropdownItem from 'Components/Atoms/Dropdown/DropdownItem/DropdownItem';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import Text from 'Components/Atoms/Text/Text';
import DeletionModal from 'Components/Molecules/Modals/Actions/DeletionModal/DeletionModal';
import TableCell from 'Components/Molecules/TableCell/TableCell';
import TableRow from 'Components/Molecules/TableRow/TableRow';
import Field from 'Components/Organisms/Field/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getInternalDatasetIdByName } from 'Services/helpers';
import ContactModuleHelper from 'Services/Settings/Modules/ContactModule/ContactModuleHelper';
import { MODULES } from 'Services/Settings/Modules/Helper';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { deleteContactModule, patchContactModules } from 'Store/Modules/ContactModule/Actions';
import { getContactByEntityId, getContactByIdAsObject, isContactLoading } from 'Store/Modules/ContactModule/Selectors';
import { StoreState } from 'Store/Reducers';
import { getEntitiesById, getEntityById } from 'Store/Settings/Entities/Selectors';
import { getModulesByEntityIdByModule } from 'Store/Settings/Modules/Selectors';
import ContactEdit from '../ContactEdit/ContactEdit';

const ContactItem = ({
    id, entity_id, record_id, isEdit = true,
    entity,
    modulesByEntityIdByModule, entityById, contactById, contact_methods,
    isLoading,
    ...props
}: ContactItemProps) => {
    const [state, setState] = useState({
        isDeleting: false,
        isOpen: false,
        isEdit: false,
        isPrimaryAvailable: false,
        showDeleteConfirmation: false,
    });

    const [data, setData] = useState<any>({});

    useEffect(() => {
        setData(contactById?.[id]);
    }, [contactById?.[id]]);

    useEffect(() => {
        const hasPrimary = contact_methods
            .filter(i => contactById?.[i]?.type == data.type)
            .find(i => contactById?.[i]?.type == data.type && contactById?.[i]?.is_primary);

        setState({...state, isPrimaryAvailable: !!!hasPrimary});
    }, [state.isEdit]);

    const handleEdit = () => setState((state) => ({
        ...state,
        isEdit: !state.isEdit
    }));

    const handleDelete = () => setState((state) => ({
        ...state,
        showDeleteConfirmation: true
    }));

    const processDelete = () => props.deleteContactModule(id);

    return <TableRow>
        <TableCell primary>
            <Text>
                { contactById?.[id]?.value || <NoValue /> }
            </Text>
        </TableCell>
        <TableCell>
            { ContactModuleHelper.getTypeLabelByValue(contactById?.[id]?.type) }
        </TableCell>
        <TableCell>
            {
                contactById?.[id]?.is_primary
                ? 'Ja'
                : 'Nee'
            }
        </TableCell>
        <TableCell>
            {
                entity.name === 'business_unit'
                && <Field
                    isEdit={false}
                    value={data.label}
                    onChange={() => {}}
                    type={FieldType.MultiSelect}
                    properties={{
                        list: modulesByEntityIdByModule
                            ?.[entity_id]
                            ?.[MODULES.CONTACT]
                            ?.configuration
                            ?.labels
                            ?.map(i => ({
                                label: i.name,
                                value: i.id
                            }))
                    }}
                />
            }
            {
                entity.name === 'contact'
                && <Field
                    isEdit={false}
                    value={data.relation}
                    onChange={() => {}}
                    type={FieldType.Multi_Selector}
                    properties={{
                        dataset: [getInternalDatasetIdByName(entityById?.[modulesByEntityIdByModule?.[entity_id]?.[MODULES.CONTACT]?.configuration?.[data.type]?.relation]?.name)],
                    }}
                />
            }
        </TableCell>
        {
            isEdit &&
            <div style={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'flex-end'
            }}>
                <Dropdown
                    position='right'
                    trigger={
                        <Button
                            size='large'
                            shape='circle'
                            color='neutral-dark'
                            iconBefore={<FontAwesomeIcon icon={faEllipsisVertical} />}
                        />
                    }
                    >
                    <DropdownItem onClick={handleEdit}>Aanpassen</DropdownItem>
                    <DropdownItem
                        border='top'
                        state='danger'
                        onClick={handleDelete}
                    >
                        Verwijderen
                    </DropdownItem>
                </Dropdown>
            </div>
        }

        {
            state.showDeleteConfirmation
            && <DeletionModal
                onClose={() => setState({
                    ...state,
                    showDeleteConfirmation: false
                })}
                onDelete={processDelete}
            >
                { contactById?.[id]?.value } zal worden verwijderd bla bla bla, niet te herstellen bla bla la
            </DeletionModal>
        }
        {
            state.isEdit
            && <ContactEdit
                id={id}
                record_id={record_id}
                entity_id={entity_id}
                onClose={handleEdit}
            />
        }
    </TableRow>;
}

interface Props {
    entity_id: string
    record_id: string
    id: string
    isEdit?: boolean
};

const mapState = (state: StoreState, props: Props) => ({
    modulesByEntityIdByModule: getModulesByEntityIdByModule(state),
    entityById: getEntitiesById(state),

    contact_methods: getContactByEntityId(state, props.record_id),
    contactById: getContactByIdAsObject(state),

    entity: getEntityById(state, props.entity_id),

    isLoading: isContactLoading(state)
});

const mapDispatch = {
    patchContactModules,
    deleteContactModule
};

type ContactItemProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(ContactItem);